
// ===== DATE FORMAT CONSTANTS =====
import dayjs from 'dayjs';
export const MONTH_SHORT_FORMAT = 'MMM'; // Jan, Feb, Mar, etc.
export const DAY_SHORT_FORMAT = 'ddd'; // Mon, Tue, Wed, etc.
export const TIME_FORMAT = 'HH:mm'; // 09:00, 14:30, etc.
export const MONTH_YEAR_FORMAT = 'MM/YYYY'; // 01/2025

export const DATE_WITH_DAY_MM_DD_FORMAT = 'MM-DD-YYYY (ddd)'; // 01-15-2025 (Wed)
export const DATETIME_MM_DD_FORMAT = 'MM-DD-YYYY (ddd) HH:mm'; // 01-15-2025 (Wed) 09:00

export const SLASH_FORMAT = 'MM/DD/YYYY'; // 01/15/2025

export const BACKEND_ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss'; // 2025-01-15T09:00:00

export const REACT_APP_M_V1_META_SECURE = process.env.REACT_APP_M_V1_META || 'vls_default_meta';

// ===== TIMEZONE UTILITIES =====
/**
 * 格式化時間為 UTC+8 的字符串
 * @param {string|Date} date - 原始日期時間
 * @param {string} format - 格式字符串，預設為 DATETIME_MM_DD_FORMAT
 * @returns {string} 格式化後的時間字符串
 */
export const formatInUTC8 = (date: string | Date, format: string = DATETIME_MM_DD_FORMAT): string => {
  // 使用 dayjs 加8小時
  return dayjs(date).add(8, 'hour').format(format);
};

export const formatDateTime = (date: string | Date, format: string = DATETIME_MM_DD_FORMAT): string => {
  // 使用 dayjs 格式化日期時間
  return dayjs(date).format(format);
};

// ===== NOTIFICATION CONSTANTS =====
export const NOTIFICATION_DURATION = 1.5;

export const MAX_ITEM_COUNT_IN_LANDING_PAGE = 5;

export const OrderStatusObj = {
  /** Reserved - 保留的 - Awaiting confirmation → C */
  RESERVED: 'N',
  /** Confirmed - 確認的 - Order confirmed → P */
  CONFIRMED: 'C',
  /** Processing - 待處理 - Being processed → O,J,D,E,G,U */
  PROCESSING: 'P',
  /** Completed - 已完成 - Successfully completed (final) */
  COMPLETED: 'O',
  /** Rejected - 已退回 - Order rejected (final) */
  REJECTED: 'J',
  /** Cancelled - 取消訂單 - Cancelled by customer (final) */
  CANCELLED: 'D',
  /** Expired - 過期未取 - Expired without pickup (final) */
  EXPIRED: 'E',
  /** Cancelled by GLUS - GLUS取消 - Cancelled by GLUS system (final) */
  CANCELLED_BY_GLUS: 'G',
  /** GLUS Updated - GLUS更新 - Updated by GLUS → P */
  GLUS_UPDATED: 'U',
} as const;